// Material Web Components Bundle
// This file imports all Material Web components and styles used in the project
import '@material/web/all.js';
import { styles as typescaleStyles } from '@material/web/typography/md-typescale-styles.js';

// Apply typescale styles globally
document.adoptedStyleSheets.push(typescaleStyles.styleSheet);

// Export for potential programmatic access
export { typescaleStyles };